module.exports = __webpack_public_path__ + "img/list.be8e7909.svg";